export const offersPageContent = {
  title: 'Unsere Bundesländer',
  subtitle: 'Abi 2022',
  appealTitle: 'Schüler',
};
